module.exports = __webpack_public_path__ + "media/images/writer/reservation/img-phone-0fbeca9d09def40607b001c2b2d12245.png";